
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ThumborOptions } from '@/filters/thumbor';

import PictureComp from '@/components/picture/PictureComp.vue';
import { AppDirection } from '@/enums/app-direction';

const Meta = namespace('meta');

@Component({
	name: 'Claim',
	components: { PictureComp },
})
export default class Claim extends Vue {
	@Meta.Getter appDirection: AppDirection;

	get isRTL(): boolean {
		return this.appDirection === AppDirection.RTL;
	}

	get backdropImage() {
		return Vue.filter('Thumbor')({
			url: this.isRTL
				? `/${ASSETS_DIR}/img/sports/bg-all-sports-1920-rtl.png`
				: `/${ASSETS_DIR}/img/sports/bg-all-sports-1920-v2.png`,
			imageType: 'backdrop',
			extension: '.webp',
		} as ThumborOptions);
	}
}
